import ResearchPage from '../components/ResearchPage';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Research | Cartwheel',
  'Explore Cartwheel research on kinematic world models, the scaling law of movement, and human motion generation for physical AI.',
);

export default ResearchPage;
